module.exports = __webpack_public_path__ + "img/guanbi.e7e3e7a1.png";